import {FETCH_INTERNSHIPLIST_REQUEST, FETCH_INTERNSHIPLIST_SUCCES, FETCH_INTERNSHIPLIST_ERROR} from '../constants/InternshipList'

const initialState = {
  count: 0,
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function internshipList(state = initialState, action) {
  switch (action.type) {
      case FETCH_INTERNSHIPLIST_REQUEST:
        return {...state, isLoading: true};
      case FETCH_INTERNSHIPLIST_SUCCES:
        return {
          ...state,
          count: action.payload.count,
          list: action.payload.results, isLoading: false
        };
      case FETCH_INTERNSHIPLIST_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/internshipList.js